import { defineStore } from "pinia";

export const useContractStore = defineStore("contract-store", {
  state: () => ({
    // Loading states
    isLoadingCreateContract: false,
    isLoadingGetContract: false,
    isLoadingUpdateContractDescription: false,
    isLoadingSubmitContractForReview: false,
    isLoadingAcceptContractReview: false,
    isLoadingRejectContractReview: false,
    isLoadingAcceptContract: false,
    isLoadingTerminateContract: false,
    isLoadingRenewContract: false,
    isLoadingArchiveContract: false,

    // Error states
    errorCreateContract: "",
    errorGetContract: "",
    errorUpdateContractDescription: "",
    errorSubmitContractForReview: "",
    errorAcceptContractReview: "",
    errorRejectContractReview: "",
    errorAcceptContract: "",
    errorTerminateContract: "",
    errorRenewContract: "",
    errorArchiveContract: "",
  }),
  actions: {
    createContract(
      orgId,
      name,
      description,
      contracteeOrgId,
      contracteeUserId,
      successHandler = () => {},
      errorHandler = () => {},
    ) {
      this.errorCreateContract = "";
      this.isLoadingCreateContract = true;
      this.apiPost(
        `/contract/org/${orgId}`,
        {
          name,
          description,
          contractee_org_id: contracteeOrgId,
          contractee_user_id: contracteeUserId,
        },
        response => {
          successHandler(response.data);
        },
        error => {
          this.errorCreateContract =
            error.response?.data?.message || "Failed to create contract";

          errorHandler(error);
        },
        () => {
          this.isLoadingCreateContract = false;
        },
      );
    },

    updateContractDescription(
      contractId,
      description,
      successHandler = () => {},
      errorHandler = () => {},
    ) {
      this.errorUpdateContractDescription = "";
      this.isLoadingUpdateContractDescription = true;
      this.apiPost(
        `/contract/${contractId}/description`,
        { description },
        response => {
          successHandler(response.data);
        },
        error => {
          this.errorUpdateContractDescription =
            error.response?.data?.message || "Failed to update description";

          errorHandler(error);
        },
        () => {
          this.isLoadingUpdateContractDescription = false;
        },
      );
    },

    submitContractForReview(
      contractId,
      orgId,
      successHandler = () => {},
      errorHandler = () => {},
    ) {
      this.errorSubmitContractForReview = "";
      this.isLoadingSubmitContractForReview = true;
      this.apiPost(
        `/contract/${contractId}/review/submit`,
        { org_id: orgId },
        response => {
          successHandler(response.data);
        },
        error => {
          this.errorSubmitContractForReview =
            error.response?.data?.message || "Failed to submit for review";

          errorHandler(error);
        },
        () => {
          this.isLoadingSubmitContractForReview = false;
        },
      );
    },

    acceptContractReview(
      contractId,
      orgId,
      successHandler = () => {},
      errorHandler = () => {},
    ) {
      this.errorAcceptContractReview = "";
      this.isLoadingAcceptContractReview = true;
      this.apiPost(
        `/contract/${contractId}/review/accept`,
        { org_id: orgId },
        response => {
          successHandler(response.data);
        },
        error => {
          this.errorAcceptContractReview =
            error.response?.data?.message || "Failed to accept review";

          errorHandler(error);
        },
        () => {
          this.isLoadingAcceptContractReview = false;
        },
      );
    },

    rejectContractReview(
      contractId,
      orgId,
      reason = "",
      successHandler = () => {},
      errorHandler = () => {},
    ) {
      this.errorRejectContractReview = "";
      this.isLoadingRejectContractReview = true;
      this.apiPost(
        `/contract/${contractId}/review/reject`,
        { org_id: orgId, reason },
        response => {
          successHandler(response.data);
        },
        error => {
          this.errorRejectContractReview =
            error.response?.data?.message || "Failed to reject review";

          errorHandler(error);
        },
        () => {
          this.isLoadingRejectContractReview = false;
        },
      );
    },

    acceptContract(
      contractId,
      orgId,
      successHandler = () => {},
      errorHandler = () => {},
    ) {
      this.errorAcceptContract = "";
      this.isLoadingAcceptContract = true;
      this.apiPost(
        `/contract/${contractId}/accept`,
        { org_id: orgId },
        response => {
          successHandler(response.data);
        },
        error => {
          this.errorAcceptContract =
            error.response?.data?.message || "Failed to accept contract";

          errorHandler(error);
        },
        () => {
          this.isLoadingAcceptContract = false;
        },
      );
    },

    terminateContract(
      contractId,
      orgId,
      successHandler = () => {},
      errorHandler = () => {},
    ) {
      this.errorTerminateContract = "";
      this.isLoadingTerminateContract = true;
      this.apiPost(
        `/contract/${contractId}/terminate`,
        { org_id: orgId },
        response => {
          successHandler(response.data);
        },
        error => {
          this.errorTerminateContract =
            error.response?.data?.message || "Failed to terminate contract";

          errorHandler(error);
        },
        () => {
          this.isLoadingTerminateContract = false;
        },
      );
    },

    renewContract(
      contractId,
      orgId,
      renewalDate,
      successHandler = () => {},
      errorHandler = () => {},
    ) {
      this.errorRenewContract = "";
      this.isLoadingRenewContract = true;
      this.apiPost(
        `/contract/${contractId}/renew`,
        { org_id: orgId, renewal_date: renewalDate },
        response => {
          successHandler(response.data);
        },
        error => {
          this.errorRenewContract =
            error.response?.data?.message || "Failed to renew contract";

          errorHandler(error);
        },
        () => {
          this.isLoadingRenewContract = false;
        },
      );
    },

    archiveContract(
      contractId,
      orgId,
      successHandler = () => {},
      errorHandler = () => {},
    ) {
      this.errorArchiveContract = "";
      this.isLoadingArchiveContract = true;
      this.apiPost(
        `/contract/${contractId}/archive`,
        { org_id: orgId },
        response => {
          successHandler(response.data);
        },
        error => {
          this.errorArchiveContract =
            error.response?.data?.message || "Failed to archive contract";

          errorHandler(error);
        },
        () => {
          this.isLoadingArchiveContract = false;
        },
      );
    },
  },
});
